var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdviseReviews = function SvgAdviseReviews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EADF1",
    d: "M16 0c-4.418 0-8 3.58-8 7.998v35.989a8 8 0 0 0 8 7.997h12v10.013c0 1.645 1.876 2.586 3.195 1.603L46.79 51.984H64c4.418 0 8-3.58 8-7.997V7.997A8 8 0 0 0 64 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2399EE",
    d: "M28 61.997c0 1.645 1.876 2.586 3.195 1.603L46.79 51.984H64c4.418 0 8-3.58 8-7.997V7.997A8 8 0 0 0 64 0H28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1081D3",
    d: "M46.79 51.984H64c4.418 0 8-3.58 8-7.997V7.997A8 8 0 0 0 64 0H35z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.254 20.994c-1.75 0-3-1.25-3-3 0-1.624 1.25-2.998 3-2.998 1.625 0 3 1.374 3 2.999 0 1.75-1.375 2.999-3 2.999m16 0c-1.75 0-3-1.25-3-3 0-1.624 1.25-2.998 3-2.998 1.625 0 3 1.374 3 2.999 0 1.75-1.375 2.999-3 2.999m-20.625 8.622v-.125c.875-.625 2.125-.625 2.875.25 2.375 2.624 5.875 4.249 9.75 4.249 3.75 0 7.25-1.625 9.625-4.249.75-.875 2-.875 2.875-.125.75.625.875 2 .125 2.75-3.125 3.498-7.625 5.623-12.625 5.623-5.125 0-9.625-2.125-12.75-5.624-.75-.75-.625-2.124.125-2.749"
  })));
};
export { SvgAdviseReviews as ReactComponent };
export default "/images/advise-reviews.svg";